<!--For building detailsview, we will show: Name, description, Site.Name, LastModifiedDate, and the site map-->
<ng-container *ngIf="project else loadingView">
    <div class="cas-flex-row">
        <ng-container *ngTemplateOutlet="details"></ng-container>
        <ng-container *ngTemplateOutlet="threeD"></ng-container>
    </div>
    <acabim-card
            *ngIf="project"
            [cardContent]="site"
            [isCollapsible]="true"
            [isCollapsed]="true"
            cardHeading="Site"
    ></acabim-card>
</ng-container>

<ng-template #details>
    <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-5">
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Name</acabim-form-input-label>
            <acabim-form-input-content [shortField]="true">
                {{project ? project.name : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Description</acabim-form-input-label>
            <acabim-form-input-content>
                {{project ? project.description : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Site</acabim-form-input-label>
            <acabim-form-input-content [shortField]="true">
                {{project ? project.site.name : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Last Modified</acabim-form-input-label>
            <acabim-form-input-content [shortField]="true">
                {{project ? (project.lastModifiedDate | ago) : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
    </acabim-form-block>
</ng-template>

<ng-template #threeD>
    <div class="col-md-7 h-100 w-100" style="display: block;">
        <acabim-bim-visualiser-threed-viewer
                [projectId]="project ? project.id : ''"></acabim-bim-visualiser-threed-viewer>
    </div>
</ng-template>

<ng-template #site>
    <div class="cas-pad">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="w-100">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Address</acabim-form-input-label>
                <acabim-form-input-content>
                    {{currentSite ? currentSite.address : ''}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <acabim-map-viewer
            #mapViewer
            [path]="mapCoordinates"></acabim-map-viewer>
    </div>
</ng-template>
<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
